module.exports = __webpack_public_path__ + "assets/leadfeeder.e858bc41.svg";